import gql from 'graphql-tag';

import tokenFragment from '../fragments/tokenFragment';

export const mutationCreateTokenVerificationHash = gql`
  mutation createTokenVerificationHash(
    $accountID: DokkioID!
    $dokkioUserID: DokkioID!
    $verificationHash: String!
  ) {
    createTokenVerificationHash(
      accountID: $accountID
      dokkioUserID: $dokkioUserID
      verificationHash: $verificationHash
    ) {
      ...tokenFragment
    }
  }
  ${tokenFragment}
`;

export default mutationCreateTokenVerificationHash;
